import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class AdditionalQuestionNps extends Component {
  labelHandler(e, chart) {
    let chartElement = chart.getElementAtEvent(e)[0];
    let dataset = chart.data.datasets[chartElement._datasetIndex];
    let label = dataset.label;
    return label;
  }

  render() {
    let options = {
      legend: { display: false },
      tooltips: {
        mode: 'nearest',
        callbacks: {
          title: function () {
            return '';
          },
          label: function (tooltipItems, data) {
            return (
              data.datasets[tooltipItems.datasetIndex].label.toString() +
              ': ' +
              tooltipItems.xLabel
            );
          },
        },
      },
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [
          {
            ticks: { beginAtZero: true },
            stacked: true,
            display: false,
            barThickness: 50,
          },
        ],
      },
    };

    const extraParams = this.props.data.survey_question
      ? { survey_question_id: this.props.data.question_id }
      : { additional_question_id: this.props.data.question_id };

    return (
      <BaseChart
        type="horizontalBar"
        id="additionalQuestionNpsDistribution"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="additional_question_response_scalar"
        chartHandler={this.props.chartHandler}
        labelHandler={this.labelHandler}
        extraParams={extraParams}
      />
    );
  }
}

export default AdditionalQuestionNps;
